import React, { useEffect, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
  errorMessage,
  formatStatus,
  formatUsername,
} from "../../../util/Helpers";
import DynamicSimpleTable from "../../../util/DynamicSimpleReactTable";
import cogoToast from "cogo-toast";
import { useDownloadUsersByTradeActivityReportMutation } from "../../../../redux/apiSlice";
import { FilterGroup } from "../../Common/components/FilterGroup";
import { Permissions, PermissionType } from "../../../util/Permissions";
import { Permission } from "../../Common/layout/Permission";

export const ActivityReportTable = () => {
  const tableRef = useRef();

  const [
    downloadTradeActivityReport,
    {
      isLoading: isLoadingReport,
      isSuccess: isReportGenerating,
      error: errorReport,
    },
  ] = useDownloadUsersByTradeActivityReportMutation();

  useEffect(() => {
    if (errorReport) {
      cogoToast.error(errorReport.data);
    }
  }, [errorReport]);

  useEffect(() => {
    if (isReportGenerating) {
      cogoToast.success(
        `Report export in progress. The resulting file will be sent to your mail.`
      );
    }
  }, [isReportGenerating]);

  return (
    <div className="py-4 px-6">
      <FilterGroup
        defaultFilters={{
          side: "buyAndSell",
          comparator: "gt",
          amount: 0,
          endDate: new Date().toISOString().split("T")[0],
        }}
      >
        <FilterGroup.DateRange className={"mb-4"} />
        <div className="d-flex">
          <div className={"mb-4 mr-4"}>
            <FilterGroup.Filter className={"mr-4"} name={"side"} label={"Side"}>
              <FilterGroup.Option value={"buyAndSell"}>
                Buy and Sell
              </FilterGroup.Option>
              <FilterGroup.Option value={"buy"}>Buy</FilterGroup.Option>
              <FilterGroup.Option value={"sell"}>Sell</FilterGroup.Option>
            </FilterGroup.Filter>
          </div>
          <div className={"mb-4"}>
            <FilterGroup.Filter
              className={"mr-4"}
              name={"comparator"}
              label={"Comparator"}
            >
              <FilterGroup.Option value={"gt"}>Greater Than</FilterGroup.Option>
              <FilterGroup.Option value={"lt"}>Less Than</FilterGroup.Option>
              <FilterGroup.Option value={"eq"}>Equals To</FilterGroup.Option>
            </FilterGroup.Filter>
          </div>
          <div className={"mb-4 mr-4"}>
            <FilterGroup.Amount name={"amount"} className={"mb-4"} />
          </div>
        </div>
        <FilterGroup.Content>
          {({ filters }) => {
            return (
              <Card>
                <CardHeader title={`Users list`}>
                  <Permission
                    permission={Permissions.REPORTS}
                    permissionType={PermissionType.CREATE}
                  >
                    <CardHeaderToolbar>
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={isLoadingReport}
                        onClick={() =>
                          downloadTradeActivityReport({
                            side: filters?.side || "buyAndSell",
                            comparator: filters?.comparator || "gt",
                            amount: filters?.amount || 0,
                            startDate: filters?.startDate || "",
                            endDate: filters?.endDate || "",
                          })
                        }
                      >
                        Export CSV
                      </button>
                    </CardHeaderToolbar>
                  </Permission>
                </CardHeader>
                <CardBody>
                  <DynamicSimpleTable
                    queryParams={
                      `side=${filters?.side || "buyAndSell"}` +
                      `&comparator=${filters?.comparator}` +
                      `&amount=${filters?.amount || 0}` +
                      `&startDate=${filters?.startDate || ""}` +
                      `&endDate=${filters?.endDate || ""}`
                    }
                    searchBox={false}
                    source={{ url: `/reports/users-by-trade-frequency` }}
                    columns={[
                      {
                        title: "USER",
                        format: (row) =>
                          formatUsername(
                            row.userId,
                            row.username,
                            null,
                            null,
                            null
                          ),
                      },
                      { title: "EMAIL", key: "email" },
                      { title: "PHONE", key: "phone" },
                      { title: "STATUS", format: row => formatStatus(row.status) },
                      { title: "KYC LEVEL", key: "level" },
                      { title: "COMPLETION", key: "completion" },
                      { title: "USER GROUP", key: "userGroup" },
                      { title: "TOTAL ORDERS", key: "totalOrders" },
                    ]}
                    onError={(err) => cogoToast.error(errorMessage(err))}
                    refreshIcon={true}
                    ref={tableRef}
                  />
                </CardBody>
              </Card>
            );
          }}
        </FilterGroup.Content>
      </FilterGroup>
    </div>
  );
};
